import styled from '@emotion/styled';
import React from 'react';
import { Icon } from '@components/common/generic-icon';
import { useI18NextContext } from '@components/hooks';
import { boxShadowMixins, mixins } from '@styles/mixins';
import { TestId } from '@components/test-ids';
import { ThemeProps } from '@theme/base';

const Container: any = styled.div(({ theme }: ThemeProps) => ({
  border: `1px solid ${theme.custom.colors.group10.light}`,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  flexDirection: 'column',
  padding: theme.custom.spacing.large,
  boxShadow: boxShadowMixins(theme.custom.colors.group10.light).lighter
}));

const Text: any = styled.h5(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.h5 as any),
  marginTop: 10,
  marginBottom: 10,
  fontWeight: 'normal',
  textAlign: 'center'
}));

const Link: any = styled.a(({ theme }: ThemeProps) => ({
  ...(theme.custom.typography.paragraph as any),
  ...mixins(theme).link,
  fontWeight: '500'
}));

const StyledIcon = styled(Icon)(({ theme }: ThemeProps) => ({
  fontSize: '3.4rem',
  color: theme.custom.colors.group4.base
}));

export interface NoResultsProps {
  icon: string;
  label: string;
  link: string;
  onClick: () => void;
}

export const NoResults = ({ icon, label, link, onClick }: NoResultsProps) => {
  const t: any = useI18NextContext();
  return (
    <Container data-testid={TestId.noResults.container}>
      <StyledIcon name={icon} />
      <Text>{t(label)}</Text>
      <Link prefetch={false} onClick={onClick}>
        {t(link)}
      </Link>
    </Container>
  );
};
